module.exports = __webpack_public_path__ + "static/media/claim.d689ec76.svg";